// Shared form field names that are common across multiple assessment types
// This provides type safety and consistency for shared components/hooks

import { DischargeFormField } from '../DischargeAssessment/types/formField'
import { RocFormField } from '../RocAssessment/types/RocFormField'
import { SupervisoryFormField } from '../SupervisoryAssessment/types/SupervisoryFormField'
import { SocFormField } from '../SocAssessment/types/SocFormField'
import { RecertFormField } from '../RecertAssessment/types/RecertFormField'
import { ServicePlanFormField } from '../ServicePlanAssessment/types/ServicePlanFormField'
import { FuaFormField } from '../FuaAssessment/types/FuaFormField'

// Const object that combines all form field enums from different assessments
export const SharedFormField = {
  ...SocFormField,
  ...ServicePlanFormField,
  ...RecertFormField,
  ...FuaFormField,
  ...RocFormField,
  ...DischargeFormField,
  ...SupervisoryFormField
} as const

// Type for the shared form field values
export type SharedFormField = (typeof SharedFormField)[keyof typeof SharedFormField]
